import React from 'react';
import { MessageCircle, Mic, Heart, BookOpen, Sun, Shield } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: <MessageCircle className="w-8 h-8" />,
      title: 'Talk to Bhagwan',
      description: 'Direct conversations with divine AI entities inspired by scriptures'
    },
    {
      icon: <Mic className="w-8 h-8" />,
      title: 'Voice Conversations',
      description: 'Speak naturally and receive spoken guidance in return'
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: 'Personalized Guidance',
      description: 'Tailored spiritual advice based on your personal journey'
    },
    {
      icon: <BookOpen className="w-8 h-8" />,
      title: 'Scripture Based Knowledge',
      description: 'Rooted in Bhagavad Gita, Vedas, Upanishads, and more'
    },
    {
      icon: <Sun className="w-8 h-8" />,
      title: 'Daily Divine Feed',
      description: 'Receive shlokas, stories, and spiritual wisdom every day'
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: 'Safe and Private Experience',
      description: 'Your conversations remain completely confidential'
    }
  ];

  return (
    <section className="py-20 relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-4 text-white">
            Features That <span className="text-gradient">Elevate Your Spirit</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Everything you need for a meaningful spiritual practice
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="divine-card p-8 hover:scale-105 transition-all duration-300 group"
            >
              <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-xl flex items-center justify-center text-white mb-6 group-hover:shadow-xl transition-shadow">
                {feature.icon}
              </div>
              <h3 className="font-serif text-xl font-bold mb-3 text-white">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;